/* prettier-ignore */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../auth/services';
import { RestService } from '../../services/rest.service';
import { ModalController } from '@ionic/angular';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from '../../shared/login/login.component';
import { LoginDialogComponent } from '../../shared/login/login-dialog/login-dialog.component';
import { RegisterDialogComponent } from '../../shared/register/register-dialog/register-dialog.component';
import Swal from "sweetalert2";
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { TranslationService } from 'src/app/services/translation.service';
import { PostLoginRedirect } from '../../auth/services/post-login-redirect.service';

@Injectable({
  providedIn: 'root',
})

export class UserService {
  private _matDialog = inject(MatDialog);
  private _translationService = inject(TranslationService);
  private _postLoginRedirect = inject(PostLoginRedirect);
  private _switchingToRegister = false;
  private loginModal: any
  public eventsInscriptions: any = [];
  public favouritesPoints: any = [];
  public favouritesEvents: any = [];
  public favouritesHikings: any = [];
  public favouritesRoutes: any = [];
  public eventsInscriptionsLoaded: boolean = false;
  public favouritesPointsLoaded: boolean = false;
  public favouritesEventsLoaded: boolean = false;
  public favouritesRoutesLoaded: boolean = false;
  public favouritesHikingsLoaded: boolean = false;

  public constructor(
    public http: HttpClient,
    public authService: AuthService,
    private rest: RestService,
    public modalCtrl: ModalController)
  {}

// ----- EVENTOS ----------------------------------------------------------------------------------------------------------------------------------------------------------------
  getFavouritesEvents(){
    const userId = this.authService.user()?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/get-events-wallet/${userId}`);
  }

  getEventsInscriptions(){
    const userId = this.authService.user()?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/get-event-registers-user/${userId}`);
  }

  addFavouriteEvent(id): any{
    const userId = this.authService.user()?.id;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const jsonData = { user_id: userId, events: [id] };
    return this.http.post(`${this.rest.apiUrlBase}/api/save-events-wallet`, jsonData, { headers: headers });
  }

  addEventInscription(id){
    const userId = this.authService.user()?.id;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const jsonData = { user_id: userId, event_id: id };
    return this.http.post(`${this.rest.apiUrlBase}/api/confirm-register-event`, jsonData, { headers: headers });
  }

  removeFavouriteEvent(id): any{
    const userId = this.authService.user()?.id;
    return this.http.delete(`${this.rest.apiUrlBase}/api/delete-event-wallet/${id}/${userId}`);
  }

// ----- PUNTOS ----------------------------------------------------------------------------------------------------------------------------------------------------------------
  getFavouritePoints(){
    const userId = this.authService.user()?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/get-interest-points-wallet/${userId}`);
  }

  addFavouritePoint(id): any{
    const userId = this.authService.user()?.id;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const jsonData = { user_id: userId, interest_points: [id] };
    return this.http.post(`${this.rest.apiUrlBase}/api/save-interest-points-wallet`, jsonData, { headers: headers });
  }

  removeFavouritePoint(id): any{
    const userId = this.authService.user()?.id;
    return this.http.delete(`${this.rest.apiUrlBase}/api/delete-interest-point-wallet/${id}/${userId}`);
  }

// ----- RUTAS ----------------------------------------------------------------------------------------------------------------------------------------------------------------
  getFavouritesRoutes(){
    const userId = this.authService.user()?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/get-routes-wallet/${userId}`);
  }

  addFavouriteRoute(id){
    const userId = this.authService.user()?.id;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const jsonData = { user_id: userId, routes: [id] };
    return this.http.post(`${this.rest.apiUrlBase}/api/save-routes-wallet`, jsonData, { headers: headers });
  }

  removeFavouriteRoute(id){
    const userId = this.authService.user()?.id;
    return this.http.delete(`${this.rest.apiUrlBase}/api/delete-route-wallet/${id}/${userId}`);
  }

// ----- HIKINGS ----------------------------------------------------------------------------------------------------------------------------------------------------------------
  getFavouritesHikings(){
    const userId = this.authService.user()?.id;
    return this.http.get(`${this.rest.apiUrlBase}/api/get-hikings-wallet/${userId}`);
  }

  addFavouriteHiking(id): any{
    const userId = this.authService.user()?.id;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const jsonData = { user_id: userId, hikings: [id] };
    return this.http.post(`${this.rest.apiUrlBase}/api/save-hikings-wallet`, jsonData, { headers: headers });
  }

  removeFavouriteHiking(id): any{
    const userId = this.authService.user()?.id;
    return this.http.delete(`${this.rest.apiUrlBase}/api/delete-hiking-wallet/${id}/${userId}`);
  }

// ----- USER INFO ----------------------------------------------------------------------------------------------------------------------------------------------------------------
  updateUserInfo(jsonData){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.rest.apiUrlBase}/api/update-personal-information`, jsonData, { headers: headers });
  }

  resetAll(){
    this.favouritesPoints = [];
    this.favouritesEvents = [];
    this.favouritesRoutes = [];
    this.favouritesHikings = [];
    this.eventsInscriptions = [];
  }


  checkUserFavouritesPoints() {
    if (this.authService.user()?.id && !this.favouritesPointsLoaded) {
      this.getFavouritePoints().subscribe((res: any) => {
        if (res.interest_points){
          this.favouritesPoints = res.interest_points;
          this.favouritesPointsLoaded = true;
        }
      });
    }
  }

  checkUserFavouritesEvents() {
    if (this.authService.user()?.id && !this.favouritesEventsLoaded) {
      this.getFavouritesEvents().subscribe((res: any) => {
        if (res.events){
          this.favouritesEvents = res.events;
          this.favouritesEventsLoaded = true;
        } 
      });
    }
  }

  checkUserFavouritesRoutes() {
    if (this.authService.user()?.id && !this.favouritesRoutesLoaded) {
      this.getFavouritesRoutes().subscribe((res: any) => {
        if (res.routes){
          this.favouritesRoutes = res.routes;
          this.favouritesRoutesLoaded = true;
        } 
      });
    }
  }

  checkUserFavouritesHikings() {
    if (this.authService.user()?.id && !this.favouritesHikingsLoaded) {
      this.getFavouritesHikings().subscribe((res: any) => {
        if (res.hikings){
          this.favouritesHikings = res.hikings;
          this.favouritesHikingsLoaded = true;
        }
      });
    }
  }

  checkUserEventsInscriptions() {
    if (this.authService.user()?.id && !this.eventsInscriptionsLoaded ) {
      this.getEventsInscriptions().subscribe((res: any) => {
        this.eventsInscriptions = res;
        this.eventsInscriptionsLoaded = true;
      });
    }
  }

  checkAllUserEntries(){
    this.checkUserFavouritesPoints();
    this.checkUserFavouritesEvents();
    this.checkUserFavouritesRoutes();
    this.checkUserFavouritesHikings();
    this.checkUserEventsInscriptions();
  }

  /**
   * HRS-3134: lo mismo que `checkAllUserEntries` para los favoritos, pero avisando
   * de cuándo han llegado.
   *
   * Hace falta porque quien entra desde el enlace del correo del registro aterriza
   * en «Mis favoritos» en el mismo instante en que inicia sesión: la lista todavía
   * venía de camino y la pantalla se quedaba vacía hasta recargar. Lo que ya
   * estuviera cargado no se vuelve a pedir.
   */
  loadUserFavourites(): Observable<void> {
    if (!this.authService.user()?.id) {
      return of(undefined);
    }

    const pending = (loaded: boolean, request: () => Observable<any>) =>
      loaded ? of(null) : request().pipe(catchError(() => of(null)));

    return forkJoin({
      points: pending(this.favouritesPointsLoaded, () => this.getFavouritePoints()),
      events: pending(this.favouritesEventsLoaded, () => this.getFavouritesEvents()),
      routes: pending(this.favouritesRoutesLoaded, () => this.getFavouritesRoutes()),
      hikings: pending(this.favouritesHikingsLoaded, () => this.getFavouritesHikings()),
    }).pipe(map((res: any) => {
      // Los endpoints contestan `{error: ...}` cuando el usuario no tiene nada
      // guardado, así que solo se asigna lo que viene con su clave.
      if (res.points?.interest_points) {
        this.favouritesPoints = res.points.interest_points;
        this.favouritesPointsLoaded = true;
      }
      if (res.events?.events) {
        this.favouritesEvents = res.events.events;
        this.favouritesEventsLoaded = true;
      }
      if (res.routes?.routes) {
        this.favouritesRoutes = res.routes.routes;
        this.favouritesRoutesLoaded = true;
      }
      if (res.hikings?.hikings) {
        this.favouritesHikings = res.hikings.hikings;
        this.favouritesHikingsLoaded = true;
      }
    }));
  }

  async login() {
    this.loginModal?.dismiss().catch(e => {
        console.warn("No modal found on dismiss")
    });
    this.loginModal = await this.modalCtrl.create({
      component: LoginComponent,
      cssClass: ['loginModal', 'ion-disable-focus-trap'],
    });
    const modal = this.loginModal;
    // HRS-3482: cerrar el login sin sesión descarta el destino pendiente; si no,
    // el siguiente que entre en este dispositivo heredaría p.ej. un ?claim= ajeno.
    // Solo si sigue siendo el modal vigente (login() reemplaza al anterior).
    modal.onDidDismiss().then(() => {
      if (this.loginModal === modal) this._forgetRedirectIfNoSession();
    });
    await modal.present();
  }

  /**
   * HRS-3482: el login se cierra para abrir el registro; el flujo sigue, así que
   * ese cierre no debe descartar el destino pendiente (p.ej. el ?claim=).
   */
  public markSwitchingToRegister(): void {
    this._switchingToRegister = true;
  }

  private _forgetRedirectIfNoSession(): void {
    const switching = this._switchingToRegister;
    this._switchingToRegister = false;
    // El cierre del REGISTRO no descarta nada: se cierra antes de que el auto-login
    // termine (no hay sesión aún) y el TTL de 10 min cubre el abandono.
    if (!switching && !this.authService.user()) this._postLoginRedirect.forget();
  }

  loginInMatDialog(): void {
    this._matDialog.open(LoginDialogComponent, {
      panelClass: 'login-mat-dialog',
      backdropClass: 'login-mat-dialog-backdrop',
    }).afterClosed().subscribe(() => this._forgetRedirectIfNoSession());
    // When the host detail page is rendered inside a CDK overlay (Mat Dialog on
    // desktop, Mat Bottom Sheet on mobile), the nested login dialog does not stack
    // on top by DOM order alone; its overlay wrapper z-index must be forced, mirroring
    // the pattern used for the 360/iframe dialogs in action-buttons.component.
    this._forceOverlayZIndex('.login-mat-dialog', '.login-mat-dialog-backdrop');
  }

  registerInMatDialog(): void {
    this.markSwitchingToRegister();
    this._matDialog.open(RegisterDialogComponent, {
      panelClass: 'register-mat-dialog',
      backdropClass: 'register-mat-dialog-backdrop',
    });
    this._forceOverlayZIndex('.register-mat-dialog', '.register-mat-dialog-backdrop');
  }

  private _forceOverlayZIndex(paneSelector: string, backdropSelector: string): void {
    requestAnimationFrame(() => {
      const pane = document.querySelector(`.cdk-overlay-pane${paneSelector}`);
      const wrapper = pane?.closest('.cdk-global-overlay-wrapper') as HTMLElement | null;
      const backdrop = document.querySelector(backdropSelector) as HTMLElement | null;
      if (wrapper) wrapper.style.zIndex = '99999';
      if (backdrop) backdrop.style.zIndex = '99998';
    });
  }

  showSuccessSwalFavourtives() {
    Swal.fire({
      title: "",
      text: this._translationService.instant("Añadido a favoritos correctamente"),
      icon: "success",
      showCancelButton: false,
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  }

    showErrorSwalFavourtives() {
      Swal.fire({
        title: "",
        text: this._translationService.instant("Error al añadir a favoritos"),
        icon: "error",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    }

}